module.exports = __webpack_public_path__ + "static/img/pic_phone_6.c35ae76.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/pic_phone_6.png
// module id = XkEy
// module chunks = 1